import videoPlayer from './js/old/videoPlayer';
import './scss/old-acf-blocks/videoplayer.scss';

videoPlayer();
